module.exports = require('./helpers/bundle-url').getBundleURL('5GWKk') + "ehl_logo.17916efe.png";